<template>
  <div class="content">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>加盟</el-breadcrumb-item>
        <el-breadcrumb-item>订单中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card style="margin-top: 20px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="订单编号"
                      prop="order_no">
          <el-input v-model.trim="query.order_no_keyword"
                    placeholder="输入订单编号"
                    @input="getList(query)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="商品名称"
                      prop="name">
          <el-input v-model="query.goods_name_keyword"
                    placeholder="输入商品名称"
                    @input="getList(query)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="商品类型"
                      prop="ref_type">
          <el-select v-model="query.product_types"
                     clearable
                     placeholder="请选择"
                     style="width: 150px"
                     @change="getList(query)">
            <el-option v-for="item in filter.refTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="下单用户"
                      prop="goods_name">
          <el-input v-model.trim="query.warrant_user_keyword"
                    placeholder="输入下单用户信息"
                    @input="getList(query)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="订单状态"
                      prop="status">
          <el-select v-model="query.statuses"
                     multiple
                     collapse-tags
                     placeholder="请选择"
                     clearable
                     @change="statusChange">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timechange"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="card-header">
        <TableTittle :tittle="TableName"></TableTittle>
      </div>
      <el-table :data="tableData"
                :header-cell-style="{
          textAlign: 'center',
          color: '#909399',
          fontFamily: 'PingFang SC',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: '#F2F6FC',
        }"
                :cell-style="{ textAlign: 'center', fontSize: '13px' }"
                border>
        <el-table-column prop="order_no"
                         label="订单编号"
                         min-width="160"
                         align="center">
        </el-table-column>
        <el-table-column prop="goods_name"
                         label="商品名称"
                         width="320"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="product_type"
                         label="商品类型">
          <template slot-scope="scope">
            <span v-show="scope.row.product_type == '1'">课程</span>
            <span v-show="scope.row.product_type == '2'">题库</span>
            <span v-show="scope.row.product_type == '3'">专栏</span>
            <span v-show="scope.row.product_type == '4'">资料</span>
          </template>
        </el-table-column>
        <el-table-column label="商品规格"
                         width="160"
                         align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{formatSkuVal(scope.row.product_sku_properties) }} <span>{{ scope.row.product_sku_price?`| 单价¥${scope.row.product_sku_price}`:''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_count"
                         label="采购份数">
          <template slot-scope="scope">
            <span>
              {{scope.row.order_count+"份" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="下单用户"
                         width="200"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
               `${scope.row.warrant_user_alias}/${scope.row.warrant_user_phone}`
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_amount"
                         label="订单金额"
                         align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.order_amount }}元</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态"
                         align="center">
          <template slot-scope="scope">
            <span>{{ statusRender(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.payment_pay_type==0">-</span>
            <span v-else-if="scope.row.payment_pay_type==1">支付宝</span>
            <span v-else-if="scope.row.payment_pay_type==2">微信</span>
            <span v-else-if="scope.row.payment_pay_type==3">余额</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time"
                         label="创建时间"
                         width="150">
          <template slot-scope="scope">
            {{ scope.row.create_time | dateFormat("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time"
                         label="更新时间"
                         width="150">
          <template slot-scope="scope">
            {{ scope.row.update_time | dateFormat("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>

        <el-table-column prop="name"
                         label="操作"
                         width="100"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="handleToOrderInfo(scope.row, scope.$index)">详情</el-link>
            <el-link type="primary"
                     :underline="false"
                     v-if="scope.row.status==3"
                     @click="handleToExpressInfo(scope.row, scope.$index)">物流</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 16px">
        <div class="block">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </el-card>
    <OrderDetail :id="orderId"
                 :visible="orderDetailDiglog"
                 :userContent="userContent"
                 @close="orderDetailDiglog = false"></OrderDetail>
    <ExpressDetail :content="orderItem"
                   :visible="expressDetailDiglog"
                   @close="expressDetailDiglog = false"></ExpressDetail>
  </div>
</template>

<script>
import { adminUrl } from '../../../utils/helper'
import TableTittle from '../../../components/TableTittle/TableTittle.vue'
import ExpressDetail from '@/components/DialogComponents/warrant/ExpressDetail'
import OrderDetail from '../../../components/DialogComponents/warrant/OrderDetail.vue'

export default {
  components: {
    TableTittle,
    ExpressDetail,
    OrderDetail,
  },
  data() {
    return {
      TableName: '订单列表',
      submitmethods: 'add',
      filter: {
        refTypes: [
          { label: '课程', value: '1' },
          { label: '题库', value: '2' },
          { label: '专栏', value: '3' },
          { label: '资料', value: '4' },
        ],
        status: [
          { label: '待支付', value: '0' },
          { label: '已支付', value: '1' },
          { label: '待发货', value: '2' },
          { label: '待收货', value: '3' },
          { label: '已取消', value: '4' },
        ],
      },
      form: {},
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      createDatetime: '',
      pageTotal: 0,
      tableData: [],
      orderItem: {},
      orderId: null,
      userContent: {},
      orderDetailDiglog: false,
      expressDetailDiglog: false,
    }
  },

  mounted() {
    this.getList(this.query)
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf()
        this.query.end_create_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
      }
    },
  },
  methods: {
    formatSkuVal(skuList) {
      if (!skuList) return '--'

      try {
        // 如果是字符串，先解析为数组
        let skuArray = skuList
        if (typeof skuList === 'string') {
          skuArray = JSON.parse(skuList)
        }

        // 如果是数组且有值，拼接 val
        if (Array.isArray(skuArray) && skuArray.length > 0) {
          return skuArray.map((item) => item.val).join(';')
        }

        return '--'
      } catch (error) {
        console.error('解析规格数据失败:', error)
        return '--'
      }
    },
    statusChange() {
      const params = Object.assign({}, this.query)
      params.statuses = params.statuses.filter((v) => v).join(',')
      this.getList(params)
    },
    timechange(e) {
      if (e == null) {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
      }
      this.getList(this.query)
    },
    handleToOrderInfo(row) {
      let user = {
        warrant_user_company_name: row.warrant_user_company_name,
        warrant_user_alias: row.warrant_user_alias,
        warrant_user_phone: row.warrant_user_phone,
      }
      this.userContent = user
      this.orderId = row.id
      this.orderDetailDiglog = true
    },
    // 物流信息
    handleToExpressInfo(row) {
      console.log('物流信息')
      this.orderItem = row
      this.expressDetailDiglog = true
    },
    statusRender(row) {
      const order_status = {
        0: '待支付',
        1: '已支付',
        2: '待发货',
        3: '待收货',
        4: '已取消',
      }
      return order_status[row.status] || ''
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getList(this.query)
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.getList(this.query)
    },

    async getList(query) {
      let str = adminUrl()
      const res = await this.$axios({
        url: `${str}/api/v1/back/crm/warrant/order/list`,
        method: 'get',
        params: query,
      })
      this.tableData = res.data.list || []
      this.pageTotal = res.data.count
    },
  },
}
</script>

<style lang="less" scoped>
.breadcrumb {
  display: flex;
  align-items: center;
  height: 30px;
  justify-content: space-between;
}
.card-header {
  display: flex;
  justify-content: space-between;
  .el-button {
    height: 35px;
    line-height: 10px;
  }
}
.block {
  margin-bottom: 14px;
  float: right;
}
</style>